import styled from '@emotion/styled';
import { ConfirmationDialog } from '../../../../../components-dummy/ConfirmationDialog';

export const RenameTagConfirmationFooter = styled(ConfirmationDialog.Footer)`
  justify-content: space-between;
  flex-direction: row;
`;
